/** Canonical footer/result status labels for media generation nodes. */

import type { TFunction } from 'i18next'

export type GenerationMediaKind = 'image' | 'video' | 'generic'

export function generationFooterRunLabel(
  status: string,
  t: TFunction<'canvas'>,
  opts: { hasResult: boolean; media: GenerationMediaKind },
): string {
  if (status === 'SUBMITTING') {
    return opts.media === 'video'
      ? t('generation.statusSubmittingVideo')
      : t('generation.statusSubmittingEllipsis')
  }
  if (status === 'QUEUED') return t('generation.statusQueuedEllipsis')
  if (status === 'WAITING_FOR_ENGINE') {
    return opts.media === 'video'
      ? t('generation.statusWaitingEngineVideo')
      : t('generation.statusWaitingEngine')
  }
  if (status === 'UPLOADING_ASSETS') return t('generation.statusUploadingAssetsEllipsis')
  if (status === 'SUBMITTING_REQUEST') return t('generation.statusSubmittingRequestEllipsis')
  if (status === 'RETRYING') return t('generation.statusRetryingEllipsis')
  if (status === 'GENERATING') return t('generation.statusGeneratingEllipsis')
  if (status === 'SYNC_ERROR') return t('generation.statusSyncError')
  if (opts.media === 'image') {
    return opts.hasResult ? t('generation.runRegenerateImage') : t('generation.runGenerateImage')
  }
  if (opts.media === 'video') {
    return opts.hasResult ? t('generation.runRegenerate') : t('generation.runGenerate')
  }
  return t('generation.runGenerate')
}

export function generationResultPlaceholderLabel(
  status: string,
  t: TFunction<'canvas'>,
  opts: { runHydrating?: boolean; showActivePreview?: boolean },
): string {
  if (status === 'SUBMITTING') return t('generation.resultSubmitting')
  if (status === 'QUEUED' || status === 'WAITING_FOR_ENGINE') return t('generation.resultWaiting')
  if (status === 'UPLOADING_ASSETS') return t('generation.resultUploadingAssets')
  if (status === 'SUBMITTING_REQUEST') return t('generation.resultSubmittingRequest')
  if (status === 'RETRYING') return t('generation.resultRetrying')
  if (status === 'GENERATING' || opts.runHydrating) return t('generation.generating')
  if (status === 'SYNC_ERROR') return t('generation.resultSyncError')
  if (status === 'FAILED') return t('media.failedFull')
  if (opts.showActivePreview) return t('generation.resultReady')
  return t('generation.resultEmpty')
}
